module.exports = __webpack_public_path__ + "img/bolt-3d.9ca4e2ba.png";